<template>
  <b-modal
    v-model="localVisible"
    :title="subtask ? $t('subtasks.completedModal.titleWith', { title: subtask.title }) : $t('subtasks.completedModal.title')"
    size="lg"
    ok-only
    :ok-title="$t('common.close')"
    centered
    ok-variant="secondary"
  >
    <div v-if="subtask">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-1 border-right"
        >
          <div class="bg-light-success p-1 rounded">
            <div class="font-weight-bold d-block">
              {{ $t('subtasks.completedModal.completedDate') }}
            </div>
            <div>{{ subtask.completed_date ? moment(subtask.completed_date).format('DD.MM.YYYY HH:mm') : '—' }}</div>
          </div>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <div class="bg-light-success p-1 rounded">
            <div class="font-weight-bold d-block">
              {{ $t('subtasks.completedModal.completedBy') }}
            </div>
            <div>{{ subtask.completed_by_name || '—' }}</div>
          </div>
        </b-col>

        <b-col
          cols="12"
        >
          <div class="pb-1 bg-light rounded p-1">
            <div class="font-weight-bold d-block">
              {{ $t('subtasks.completedModal.closingNote') }}
            </div>
            <div
              v-if="subtask.result_notes"
              style="white-space: pre-line; max-height: 300px; overflow-y: auto;"
            >{{ subtask.result_notes }}</div>
            <div
              v-else
              class="text-muted"
            >{{ $t('subtasks.completedModal.noNote') }}</div>
          </div>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <div
        v-if="showReopen"
        class="w-100 d-flex justify-content-between align-items-center"
      >
        <div>
          <b-button
            variant="danger"
            pill
            :disabled="reopening"
            @click="reopenSubtask"
          >
            <b-spinner
              v-if="reopening"
              small
            />
            <FeatherIcon
              v-else
              icon="RotateCcwIcon"
            />
            {{ $t('subtasks.completedModal.reopen') }}
          </b-button>
        </div>
      </div>
      <div v-else />
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'CompletedSubtaskModal',
  components: {
    BModal, BRow, BCol, BButton, BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    subtask: {
      type: Object,
      default: null,
    },
    canReopen: {
      type: Boolean,
      default: false,
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
    showToast: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      reopening: false,
    }
  },
  computed: {
    moment() {
      return moment
    },
    showReopen() {
      return !!this.subtask
        && this.canReopen
        && moment().diff(this.subtask.completed_date, 'hours') < 24
    },
    localVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
    },
  },
  methods: {
    reopenSubtask() {
      this.reopening = true
      this.$store.dispatch('subtasks/reopenSubtask', this.subtask.id)
        .then(response => {
          if (response.status) {
            this.localVisible = false
            this.refreshData()
            this.showToast({
              variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: response.message,
            })
          } else {
            this.showToast({
              variant: 'warning', title: this.$t('subtasks.completedModal.systemWarning'), icon: 'CheckIcon', text: response.message,
            })
          }
        })
        .catch(() => {
          this.showToast({
            variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: this.$t('subtasks.completedModal.reopenFailed'),
          })
        })
        .finally(() => {
          this.reopening = false
        })
    },
  },
}
</script>
